var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"image-panorama"},[_c('span',{style:({'background-image': 'url(' + require('@/content/welcome-image-1.jpg') + ')'})})])
}
var staticRenderFns = []

export { render, staticRenderFns }